import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'qmTableFilter'
})
export class QmTableFilterPipe implements PipeTransform {

  transform(items: any[], fields: string[], value: string): any[] {
    console.log('FILTER');
    console.log(fields);
    console.log(value);
    console.log(items);
    if (!items) {
      return [];
    }
    if (!fields || !value || fields.length === 0) {
      return items;
    }
    return items.filter(entry => {
      for (const field of fields) {
        try {
          if (entry[field] === value) {
            return true;
          } else if (entry[field].startsWith(value)) {
            return true;
          }
        } catch (e) {
          console.warn(e);
        }
      }
      return false;
    });
  }

}
